<template>
  <div class="wrapper flex-row align-center justify-center full-parent">
    <div class="info-block flex-column align-start justify-start">
      <slideInfo
        title="精选月嫂#保障优质服务"
        desc="妈妈来了拥有完善的月嫂招募选拔体系，进入妈妈来了的月嫂必须通过1面/2查/3考/4访/5训/6评，招聘通过率仅18%"
        buttonText="选月嫂"
      />
    </div>
    <div class="progress-swiper-block">
      <swiper
        :lazy="{ loadPrevNext: true }"
        :simulateTouch="false"
        class="progress-swiper full-parent"
        :autoplay="{ delay: 3000 }"
        @swiper="swiper = $event"
        @slideChange="swiperIndex = $event.activeIndex"
      >
        <swiper-slide v-for="(item, index) of swiperList" :key="index">
          <img
            draggable="false"
            class="bg full-parent swiper-lazy"
            :data-src="item.img"
          />
          <div class="swiper-lazy-preloader" />
        </swiper-slide>
      </swiper>

      <div class="progress-swiper-pagination flex-row">
        <div
          v-for="(item, index) of swiperList"
          :key="index"
          :class="[
            'pagination-item flex-row align-center justify-center pointer',
            {
              active: swiperIndex == index,
              divider:
                index != swiperIndex &&
                index != swiperIndex - 1 &&
                index != swiperList.length - 1,
            },
          ]"
          @click="swiper.slideTo(index)"
        >
          <div class="title">{{ item.title }}</div>
          <div class="desc-block">
            <div
              v-for="(descItem, descIndex) of item.desc.split('#')"
              :key="descIndex"
              class="desc"
            >
              {{ descItem }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <decorate :list="decorateList" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay, Lazy } from "swiper";
require("swiper/swiper.less");
require("swiper/components/lazy/lazy.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Autoplay, Lazy]);
export default defineComponent({
  components: {
    slideInfo,
    ...SWIPER_COMPONENTS,
  },

  data() {
    return {
      swiper: null,
      swiperIndex: 0,
      swiperList: [
        { title: "1面", desc: "个人形象不过关不要#穿着打扮邋遢或过度的不要#沟通能力不过关的不要", img: 'https://mm2015.mamalaile.com.cn/b658fc53223af44098c5ef32f11464a5.jpg' },
        { title: "2查", desc: "三证审查不达标的不要#家庭背景调查不过关的不要#年龄、学历、历史工作审查不过关不要", img: 'https://mm2015.mamalaile.com.cn/cbcef8f6a256a45c6c2fa639e55c2370.jpg' },
        { title: "3考", desc: "理论考试不过关的不要#实操考试不过关的不要#心理素质、抗压能力不过关的不要", img: 'https://mm2015.mamalaile.com.cn/354566423daf9ba5b4833b302daf6ec5.jpg' },
        { title: "4访", desc: "前雇主访谈不过关的不要#同行调查口碑不好的不要", img: 'https://mm2015.mamalaile.com.cn/48d0751b48ca60e7f9c573e65904c501.jpg' },
        { title: "5训", desc: "参加妈妈来了岗前培训#接受统一的规范要求#培训过程表现不合格淘汰", img: 'https://mm2015.mamalaile.com.cn/5f2abe6ca52f370ab13ea41d43b43ec1.jpg' },
        { title: "6评", desc: "场景模拟评审#专家委员会评审#妈妈评审团评审", img: 'https://mm2015.mamalaile.com.cn/467ff7af09bdbacf28b4f5a844daa9d2.jpg' },
      ],
      decorateList: [
        { position: 'bottom-left', url: require('/src/assets/images/home_pic2_bg@2x.png'), width: 28.07 },
      ]
    };
  },
});
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;

  .info-block {
    width: 100%;
    padding-left: 6.82vw;
  }

  .progress-swiper-block {
    position: relative;
    width: 60.94vw;
    height: 100%;
    flex-shrink: 0;

    .progress-swiper {
      .bg {
        object-fit: cover;
      }
    }

    .progress-swiper-pagination {
      width: 100%;
      height: 7.92vw;
      position: absolute;
      z-index: 1;
      left: 0;
      bottom: 0;
      backdrop-filter: blur(4px);
      background-color: rgba(0, 0, 0, 0.6);

      .pagination-item {
        flex: 1;
        overflow: hidden;
        position: relative;
        color: white;
        transition: flex 0.4s ease, background-color 0.4s ease;

        &::after {
          content: "";
          width: 1px;
          height: 2.08vw;
          position: absolute;
          right: 0;
          top: 50%;
          opacity: 0;
          background-color: white;
          transform: translateY(-50%);
          transition: opacity 0.3s ease;
        }

        &.divider::after {
          opacity: 1;
        }

        .title {
          font-size: 1.82vw;
          line-height: 2.5vw;
          text-align: center;
          writing-mode: vertical-lr;
          text-orientation: upright;
          font-family: @font-ab;
        }

        .desc-block {
          max-width: 0;
          opacity: 0;
          margin-left: 0;
          transition: max-width 0.4s ease, opacity 0s ease,
            margin-left 0.4s ease;

          .desc {
            font-size: 0.73vw;
            line-height: 1.56vw;
          }
        }

        &.active {
          flex: 2.33;
          background-color: rgba(0, 0, 0, 0.5); // 1-(1-0.6)*(1-x)=0.8; x=0.5

          .desc-block {
            max-width: 10.5vw;
            opacity: 1;
            margin-left: 2vw;
            transition: max-width 0.4s ease, opacity 0.4s ease 0.3s,
              margin-left 0.4s ease;
          }
        }
      }
    }
  }
}
</style>